<vex-page-layout>

    <vex-page-layout-header class="pb-1 flex flex-col items-start justify-center">
    </vex-page-layout-header>

    <vex-page-layout-content>
        <div class="card overflow-auto -mt-16">
            <div class="mr-5 ml-5 mt-5">
                <div *ngIf="dashboardVo!==undefined">

                    <h4 class="my-6 headline mt-0 mb-4 text-center">
                        Estadísticas de personas desaparecidas y
                        posibles víctimas de trata y tráfico
                    </h4>
                    <div class="my-6 container flex flex-col sm:flex-row items-stretch sm:items-start gap-6">
                        <div class="card p-4 flex-1 flex flex-col items-center bg-primary text-primary-contrast">
                            <h4 class="text-center">Total personas desaparecidas</h4>
                            <h3 class="display-2 font-bold">{{dashboardVo.desaparecidos.total}}</h3>
                            <div class="body-1"><span class="body-2">Personas</span></div>
                        </div>
                    </div>

                    <div class="my-6 container flex flex-col sm:flex-row items-stretch sm:items-start gap-6">
                        <div class="card p-4 flex-1 flex flex-col items-center bg-red text-primary-contrast">
                            <h4 class="text-center">Personas no encontradas</h4>
                            <h3 class="display-2 font-bold">{{dashboardVo.desaparecidos.noEncontradas.total}}</h3>
                            <div class="body-1"><span class="body-2">{{(dashboardVo.desaparecidos.noEncontradas.total *
                                    100/dashboardVo.desaparecidos.total).toFixed(2)
                                    }} % del total</span></div>
                        </div>
                        <div class="card p-4 flex-1 flex flex-col items-center bg-green text-primary-contrast">
                            <h4 class="text-center">Personas encontradas</h4>
                            <h3 class="display-2 font-bold">{{dashboardVo.desaparecidos.encontradas.total}}</h3>
                            <div class="body-1"><span class="body-2">{{(dashboardVo.desaparecidos.encontradas.total *
                                    100/dashboardVo.desaparecidos.total).toFixed(2)
                                    }} % del total</span></div>
                        </div>
                    </div>

                    <div class="my-6 container flex flex-col sm:flex-row items-stretch sm:items-start gap-6">
                        <div class="card p-4 flex-1 flex flex-col items-center">
                            <h4 class="text-center">Total personas no encontradas</h4>
                            <div id="chartDesaparecidoNoEncontrado">
                                <apx-chart [series]="chartDesaparecidoNoEncontradoOptions.series"
                                    [chart]="chartDesaparecidoNoEncontradoOptions.chart"
                                    [labels]="chartDesaparecidoNoEncontradoOptions.labels"
                                    [responsive]="chartDesaparecidoNoEncontradoOptions.responsive">
                                </apx-chart>
                            </div>
                        </div>
                        <div class="card p-4 flex-1 flex flex-col items-center">
                            <h4 class="text-center">Total personas encontradas</h4>
                            <div id="chartDesaparecidoEncontrado">
                                <apx-chart [series]="chartDesaparecidoEncontradoOptions.series"
                                    [chart]="chartDesaparecidoEncontradoOptions.chart"
                                    [labels]="chartDesaparecidoEncontradoOptions.labels"
                                    [responsive]="chartDesaparecidoEncontradoOptions.responsive">
                                </apx-chart>
                            </div>
                        </div>
                    </div>


                    <h4 class="my-6 headline mt-0 mb-4 text-center">
                        Personas encontradas que recibieron servicios del GAMLP
                    </h4>

                    <div class="my-6 container flex flex-col sm:flex-row items-stretch sm:items-start gap-6">
                        <div class="card p-4 flex-1 flex flex-col items-center bg-primary text-primary-contrast">
                            <h4 class="text-center">Personas encontradas</h4>
                            <h3 class="display-2 font-bold">{{dashboardVo.encontradas.total}}</h3>
                            <div class="body-1"><span class="body-2">Personas</span></div>
                        </div>
                    </div>

                    <div class="my-6 container flex flex-col sm:flex-row items-stretch sm:items-start gap-6">
                        <div class="card p-4 flex-1 flex flex-col items-center bg-green text-primary-contrast">
                            <h4 class="text-center">Recibieron servicios del GAMLP</h4>
                            <h3 class="display-2 font-bold">{{dashboardVo.encontradas.servicios.total}}</h3>
                            <div class="body-1"><span class="body-2">{{(dashboardVo.encontradas.servicios.total * 100
                                    /dashboardVo.encontradas.total).toFixed(2)}} % del total</span></div>
                        </div>
                        <div class="card p-4 flex-1 flex flex-col items-center bg-red text-primary-contrast">
                            <h4 class="text-center">No recibieron servicios del GAMLP</h4>
                            <h3 class="display-2 font-bold">{{dashboardVo.encontradas.sinServicios.total}}</h3>
                            <div class="body-1"><span class="body-2">{{(dashboardVo.encontradas.sinServicios.total * 100
                                    /dashboardVo.encontradas.total).toFixed(2)}} % del total</span></div>
                        </div>
                    </div>

                    <div class="my-6 container flex flex-col sm:flex-row items-stretch sm:items-start gap-6">
                        <div class="card p-4 flex-1 flex flex-col items-center">
                            <h4 class="text-center">Recibieron servicios del GAMLP</h4>
                            <div id="chartEncontradoServicio">
                                <apx-chart [series]="chartEncontradoServicioOptions.series"
                                    [chart]="chartEncontradoServicioOptions.chart"
                                    [labels]="chartEncontradoServicioOptions.labels"
                                    [responsive]="chartEncontradoServicioOptions.responsive"></apx-chart>
                            </div>
                        </div>
                        <div class="card p-4 flex-1 flex flex-col items-center">
                            <h4 class="text-center">No recibieron servicios del GAMLP</h4>
                            <div id="chartEncontradoSinServicio">
                                <apx-chart [series]="chartEncontradoSinServicioOptions.series"
                                    [chart]="chartEncontradoSinServicioOptions.chart"
                                    [labels]="chartEncontradoSinServicioOptions.labels"
                                    [responsive]="chartEncontradoSinServicioOptions.responsive"></apx-chart>
                            </div>
                        </div>
                    </div>

                    <h4 class="my-6 headline mt-0 mb-4 text-center">
                        Personas encontradas que recibieron servicios del GAMLP {{role._id_rol}}
                    </h4>
                    <div *ngIf="role.id_rol == 64 || role.id_rol == 65">
                        <div class="my-6 container flex flex-col sm:flex-row items-stretch sm:items-start gap-6">
                            <div class="card p-4 flex-1 flex flex-col items-center bg-green text-primary-contrast">
                                <h4 class="text-center">Servicios de Salud</h4>
                                <h3 class="display-2 font-bold">{{dashboardVo.servicios.salud.total}}</h3>
                                <div class="body-1"><span class="body-2">{{((dashboardVo.servicios.salud.total * 100 )/
                                        dashboardVo.servicios.total).toFixed(2)}} % del total</span></div>
                            </div>

                            <div class="card p-4 flex-1 flex flex-col items-center bg-red text-primary-contrast">
                                <h4 class="text-center">Servicios del DNA</h4>
                                <h3 class="display-2 font-bold">{{dashboardVo.servicios.dna.total}}</h3>
                                <div class="body-1"><span class="body-2">{{(dashboardVo.servicios.dna.total * 100/
                                        dashboardVo.servicios.total).toFixed(2)}} % del total</span></div>
                            </div>

                            <div class="card p-4 flex-1 flex flex-col items-center bg-primary text-primary-contrast">
                                <h4 class="text-center">Ambos servicios</h4>
                                <h3 class="display-2 font-bold">{{dashboardVo.servicios.ambos.total}}</h3>
                                <div class="body-1"><span class="body-2">{{(dashboardVo.servicios.ambos.total * 100/
                                        dashboardVo.servicios.total).toFixed(2)}} % del total</span></div>
                            </div>
                        </div>

                        <div class="my-6 container flex flex-col sm:flex-row items-stretch sm:items-start gap-6">
                            <div class="card p-4 flex-1 flex flex-col items-center">
                                <h4 class="text-center">Servicios de Salud</h4>
                                <div id="chartServicioSalud">
                                    <apx-chart [series]="chartServicioSaludOptions.series"
                                        [chart]="chartServicioSaludOptions.chart"
                                        [labels]="chartServicioSaludOptions.labels"
                                        [responsive]="chartServicioSaludOptions.responsive"></apx-chart>
                                </div>
                            </div>
                            <div class="card p-4 flex-1 flex flex-col items-center">
                                <h4 class="text-center">Servicios del DNA</h4>
                                <div id="chartServicioDna">
                                    <apx-chart [series]="chartServicioDnaOptions.series"
                                        [chart]="chartServicioDnaOptions.chart"
                                        [labels]="chartServicioDnaOptions.labels"
                                        [responsive]="chartServicioDnaOptions.responsive"></apx-chart>
                                </div>
                            </div>
                            <div class="card p-4 flex-1 flex flex-col items-center">
                                <h4 class="text-center">Ambos servicios</h4>
                                <div id="chartServicioAmbos">
                                    <apx-chart [series]="chartServicioAmbosOptions.series"
                                        [chart]="chartServicioAmbosOptions.chart"
                                        [labels]="chartServicioAmbosOptions.labels"
                                        [responsive]="chartServicioAmbosOptions.responsive"></apx-chart>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="role.id_rol == 66">
                        <div class="my-6 container flex flex-col sm:flex-row items-stretch sm:items-start gap-6">
                            <div class="card p-4 flex-1 flex flex-col items-center bg-green text-primary-contrast">
                                <h4 class="text-center">Servicios de Salud</h4>
                                <h3 class="display-2 font-bold">{{dashboardVo.servicios.salud.total}}</h3>
                                <div class="body-1"><span class="body-2">{{((dashboardVo.servicios.salud.total * 100 )/
                                        dashboardVo.servicios.total).toFixed(2)}} % del total</span></div>
                            </div>
                        </div>

                        <div class="my-6 container flex flex-col sm:flex-row items-stretch sm:items-start gap-6">
                            <div class="card p-4 flex-1 flex flex-col items-center">
                                <h4 class="text-center">Servicios de Salud</h4>
                                <div id="chartServicioSalud">
                                    <apx-chart [series]="chartServicioSaludOptions.series"
                                        [chart]="chartServicioSaludOptions.chart"
                                        [labels]="chartServicioSaludOptions.labels"
                                        [responsive]="chartServicioSaludOptions.responsive"></apx-chart>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="role.id_rol == 67">
                        <div class="my-6 container flex flex-col sm:flex-row items-stretch sm:items-start gap-6">
                            <div class="card p-4 flex-1 flex flex-col items-center bg-red text-primary-contrast">
                                <h4 class="text-center">Servicios del DNA</h4>
                                <h3 class="display-2 font-bold">{{dashboardVo.servicios.dna.total}}</h3>
                                <div class="body-1"><span class="body-2">{{(dashboardVo.servicios.dna.total * 100/
                                        dashboardVo.servicios.total).toFixed(2)}} % del total</span></div>
                            </div>
                        </div>

                        <div class="my-6 container flex flex-col sm:flex-row items-stretch sm:items-start gap-6">
                            <div class="card p-4 flex-1 flex flex-col items-center">
                                <h4 class="text-center">Servicios del DNA</h4>
                                <div id="chartServicioDna">
                                    <apx-chart [series]="chartServicioDnaOptions.series"
                                        [chart]="chartServicioDnaOptions.chart"
                                        [labels]="chartServicioDnaOptions.labels"
                                        [responsive]="chartServicioDnaOptions.responsive"></apx-chart>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </vex-page-layout-content>
</vex-page-layout>